import { useTranslations } from 'next-intl';
import { z } from 'zod';

// Minimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character

export const getLoginFormSchema = ({
  t
}: {
  t: ReturnType<typeof useTranslations>
}) => {
  return z.object({
    email: z.string().min(2, {
      message: t('form.inputs.email.minCharacters')
    }),
    password: z
      .string()
      .min(1, { message: t('form.inputs.password.minCharacters') })
  });
};

export type LoginFormValues = z.infer<ReturnType<typeof getLoginFormSchema>>

export type PostLoginRequest = LoginFormValues

const DEFAULT_INITIAL_VALUES: LoginFormValues = {
  email: '',
  password: ''
};

export const getInitialDefaultValues = ({
  defaultInitialValues
}: {
  defaultInitialValues?: Partial<LoginFormValues>
}): Partial<LoginFormValues> => ({
  ...DEFAULT_INITIAL_VALUES,
  ...defaultInitialValues
});
